<template>
	<v-text-field
		:rules="rules"
		type="text"
		v-model="textValue"
		:label="label"
		outlined
		clearable
	></v-text-field>
</template>
<script>
import {
	FieldRules
} from '@/components';

export default {
	name: 'TextInput',
	props: {
		value: String,
		isRequired: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			required: true,
		},
	},
	computed: {
		textValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		rules() {
			const rules = [];
			const { requiredValid } = FieldRules;
			if (this.isRequired) {
				const rule = (value) =>
					requiredValid(value) ||
					this.$t('common.required-field-message');
				rules.push(rule);
			}

			return rules;
		},
	},
};
</script>